import { Box, Text, theme } from '@bpba/ui-components';
import React from 'react';
import styled from 'styled-components';
import { TypographyProps, typography } from 'styled-system';

type CategoriaProps = {
  titulo?: string | undefined;
};

export const Categoria = ({ titulo }: CategoriaProps) => {

  return (
    <StyledDiv
      borderBottomLeftRadius={'0px'}
      borderBottomRightRadius={'8px'}
      right={'unset'}
      fontSize={'14px'}
      lineHeight={'16px'}
    >
      <Text fontWeight={500} style={{ color: theme.colors.white }}>
        {titulo}
      </Text>
    </StyledDiv>
  );
};

const StyledDiv = styled(Box)<TypographyProps>(typography, {
  width: 'auto',
  position: 'absolute',
  display: 'block',
  padding: '5px 10px 5px 10px',
  backgroundColor: 'rgb(39, 157, 46)'
});